import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

import {Button, Alert} from 'react-bootstrap';
import {injectIntl, FormattedMessage} from 'react-intl';
import SpogLink from 'router-with/ui/SpogLinkRoute';

import Spinner from 'react-spinkit';

import Input from 'components/ui/form/Input';
import SpogCheckbox from 'components/ui/form/SpogCheckbox';

import 'style/components/login/login-form.scss';

/** Component to render a Login form */
class LoginForm extends Component {

    static propTypes = {
        isFetching: PropTypes.bool, // True when the form is fetching
        loginError: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]), // The last happened error
        onSubmit:   PropTypes.func, // Listener when the form is submitted
        remember:   PropTypes.bool // True when the login must be remembered
    };

    state = {
        username: '', // The current username field
        password: '', // The current password field
        remember: false // The current remember field
    };

    /**
     * Set the initial state
     * Set this to handlers
     */
    componentWillMount() {
        const {remember} = this.props;

        this.setState({
            remember
        });

        this.handlerSubmit = this.handlerSubmit.bind(this);
        this.handlerPasswordInput = this.handlerPasswordInput.bind(this);
        this.handlerRemember = this.handlerRemember.bind(this);
        this.handlerUsernameInput = this.handlerUsernameInput.bind(this);
    }

    /**
     * Update the remember state
     */
    componentWillReceiveProps(nextProps) {
        const {remember} = this.props;

        nextProps.remember !== remember && this.setState({
            remember: nextProps.remember
        });
    }

    /**
     * Focus the user field
     */
    componentDidMount() {
        ReactDOM.findDOMNode(this.refs.username).focus();
    }

    /**
     * Do the submit action
     * @param {Event} e The event object
     */
    handlerSubmit(e) {
        e.preventDefault();

        const
            {
                username,
                password,
                remember
            } = this.state,
            {
                isFetching,
                onSubmit
            } = this.props;

        !isFetching && onSubmit && onSubmit(username, password, remember);
    }

    /**
     * Update the username state
     * @param {String} username The new username
     */
    handlerUsernameInput(username) {
        this.setState({username});
    }

    /**
     * Update the username state
     * @param {String} password The new password
     */
    handlerPasswordInput(password) {
        this.setState({password});
    }

    /**
     * Update the remember state
     * @param {Boolean} remember The new remember value
     */
    handlerRemember(remember) {
        this.setState({remember});
    }

    renderAlert() {

        const {loginError} = this.props;

        return loginError ?
            <Alert className="login-alert" bsStyle="danger">{loginError}</Alert> :
            null;
    }

    renderButtonContent() {
        const {isFetching, intl: {formatMessage}} = this.props;

        return isFetching ?
            [
                <Spinner key="login-spinner" name="circle" className="login-spinner" fadeIn="none" />,
                <span key="login-spinner-text" className="login-spinner-text">{formatMessage({id: 'btn.signing_in'})}</span>
            ] :
            formatMessage({id: 'btn.sign_in'});
    }

    render() {
        const
            {isFetching, intl: {formatMessage}} = this.props,
            {username, password, remember} = this.state;
        const resetUrl = '/reset-password';


        return (
            <div data-test="component-login_form">
                <h2>
                    <FormattedMessage id="title.sign_in"/>
                </h2>
                { this.renderAlert() }
                <form onSubmit={ this.handlerSubmit }>
                    <Input
                        ref="username"
                        name="username"
                        bsSize="large"
                        autoFocus
                        placeholder={formatMessage({id: 'label.username'})}
                        glyph="user"
                        value={username}
                        disabled={isFetching}
                        onChange={this.handlerUsernameInput}
                        datacy="username"
                    />
                    <Input
                        name="password"
                        ref="password"
                        type="password"
                        bsSize="large"
                        placeholder={formatMessage({id: 'label.password'})}
                        glyph="lock"
                        value={password}
                        disabled={isFetching}
                        onChange={this.handlerPasswordInput}
                        datacy="password"
                    />
                    <SpogCheckbox
                        ref="remember"
                        bsSize="large"
                        label={formatMessage({id: 'label.remember_credentials'})}
                        value={remember}
                        disabled={isFetching}
                        onChange={this.handlerRemember}
                    />
                    <Button
                        className="btn-login btn-loginNewColor"
                        bsSize="large"
                        bsStyle="login"
                        block
                        type="submit"
                        disabled={isFetching}
                        datacy="login-button"
                    >
                        {this.renderButtonContent()}
                    </Button>
                </form>
                <SpogLink to={resetUrl}>
                    <div className="link-login">
                        <FormattedMessage id="label.forgot_password"/>
                    </div>
                </SpogLink>
                <div style={{margin: '50px 0px 0px 0px'}}>
                    <h3>{formatMessage({ id: 'contact.info.header' })}</h3>
                    <p>
                        {formatMessage({ id: 'contact.info.phone' })}: <a href="tel:+34911980732">+ 34 911 980 732&nbsp;&nbsp;</a>
                        <small style={{fontFamily: 'Rubik-Medium'}}>{formatMessage({ id: 'contact.info.customer_service' })}</small><br/>
                        Email:<a href="mailto:ems.spain@eu.equinix.com"> ems.spain@eu.equinix.com</a></p>
                </div>
            </div>
        );
    }
}

export default injectIntl(LoginForm);



// WEBPACK FOOTER //
// ./src/components/login/LoginForm.jsx